import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { TextField, Box } from '@mui/material';

// Enable UTC handling in dayjs
dayjs.extend(utc);

const MyDatePicker = ({ selected, onChange }) => {
  // Convert the initial date to a UTC string
  const [displayValue, setDisplayValue] = useState(() => {
    return dayjs(selected).utc().format('YYYY-MM-DD');
  });
  
  // Update display value when selected prop changes from parent
  useEffect(() => {
    const formattedDate = dayjs(selected).utc().format('YYYY-MM-DD');
    // console.log("External date update:", selected.toISOString());
    // console.log("Setting display value to:", formattedDate);
    setDisplayValue(formattedDate);
  }, [selected]);
  
  // Function to handle user input
  const handleInputChange = (event) => {
    const date = event.target.value;
    // console.log("Selected date string (user selection):", date);
    
    // Parse the date string and convert to a UTC date object
    const utcDate = dayjs.utc(date, 'YYYY-MM-DD').toDate();
    // console.log("Converted to UTC (for storage):", utcDate.toISOString());
    
    // Update state and parent handler with the new UTC date
    setDisplayValue(date);
    onChange(utcDate);
  };
  
  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      {/* Use a text input with type="date" to select and display date */}
      <TextField
        label="Selected Date (UTC)"
        type="date"
        value={displayValue}
        onChange={handleInputChange}
        InputLabelProps={{ shrink: true }}
        sx={{ minWidth: '200px' }}
      />
    </Box>
  );
};

export default MyDatePicker;